<script setup>
defineProps({
  label: String,
  options: Array,
  modelValue: [String, Boolean],
  name: String,
  required: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['update:modelValue']);
</script>

<template>
  <fieldset>
    <legend class="font-ibm-plex-mono! font-medium! text-base! leading-tight! text-aqua! mb-4! lg:mb-2.5!">{{ label }}</legend>

    <label v-for="(item, index) in options" :key="index" class="flex! items-center! gap-1.75! mb-2!">
      <input
        type="radio"
        :name="name"
        :value="item.value"
        :required="required"
        :checked="modelValue === item.value"
        @change="$emit('update:modelValue', item.value)"
        class="radio-input"
      />
      <p class="font-ibm-plex-mono! font-medium! text-base! leading-tight! text-black!">{{ item.option }}</p>
    </label>
  </fieldset>
</template>
